import type {
  UseMutationOptions,
  UseMutationResult,
  DefaultError,
  QueryClient,
} from '@tanstack/react-query';

import { useMutation as useReactMutation } from '@tanstack/react-query';

import type { BaseApiErrorResponse } from '../../api/types/api.types';

/**
 * Serves as base query for mutating data
 */
export default function useMutation<
  TData = unknown,
  TError = DefaultError,
  TVariables = void,
  TContext = unknown,
>(
  options: UseMutationOptions<
    TData,
    BaseApiErrorResponse<TError | null>,
    TVariables,
    TContext
  > & { skipUnhandledRejection?: boolean },
  queryClient?: QueryClient,
): UseMutationResult<
  TData,
  BaseApiErrorResponse<TError | null>,
  TVariables,
  TContext
> {
  // Returned AS IS — see the note in `useQuery`. The rebuild was the identity,
  // and it cost the result union plus React Query's render tracking.
  return useReactMutation(options, queryClient);
}
